import { render } from "./TableCell.vue?vue&type=template&id=789201b8&scoped=true&ts=true"
import script from "./TableCell.vue?vue&type=script&lang=ts"
export * from "./TableCell.vue?vue&type=script&lang=ts"

import "./TableCell.vue?vue&type=style&index=0&id=789201b8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789201b8"]])

export default __exports__